/** Avatar images by antonioChat.avatar, as paths on the webapp's own origin. */
export const ANTONIO_AVATAR_SRC_BY_NAME = {
	tonia: '/pixeltonia-hires.webp',
	toni: '/pixeltoni-hires.webp',
	lvm: '/lvm.svg'
};
